import { UPDATE_ACCOUNT, UPDATE_ACCOUNT_FAILED } from '../constants/account.constants';

// `v4UserIds` get full access once the account exists — V4 create only.
export const updateAccount = (account, v4UserIds) => ({ type: UPDATE_ACCOUNT, account, v4UserIds });
export const updateAccountFailed = () => ({ type: UPDATE_ACCOUNT_FAILED });
